import { render, staticRenderFns } from "./QuoteIncidentNotes.vue?vue&type=template&id=19cbd382"
import script from "./QuoteIncidentNotes.vue?vue&type=script&lang=js"
export * from "./QuoteIncidentNotes.vue?vue&type=script&lang=js"
import style0 from "./QuoteIncidentNotes.vue?vue&type=style&index=0&id=19cbd382&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19cbd382')) {
      api.createRecord('19cbd382', component.options)
    } else {
      api.reload('19cbd382', component.options)
    }
    module.hot.accept("./QuoteIncidentNotes.vue?vue&type=template&id=19cbd382", function () {
      api.rerender('19cbd382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteRemarks/QuoteIncidentNotes.vue"
export default component.exports